import React from "react";
import TrackingHeader from "./TrackingHeader";
import SenderReceiverInfo from "./SenderReceiverInfo";
import RealTimeTracking from "./RealTimeTracking";

const TrackingDetailsCard = ({ trackingData }) => {
  if (!trackingData) return null;

  return (
    <div className="inline-tracking-details">
      <TrackingHeader trackingData={trackingData} />
      <SenderReceiverInfo trackingData={trackingData} />
      <RealTimeTracking trackingData={trackingData} />
    </div>
  );
};

export default TrackingDetailsCard;
